import settings from '../../api/settings/hooks'

const useLocaleOptions = () => {
    const { data: availableTranslationLanguages = [] } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.availableTranslationLanguages,
    })

    const locales = availableTranslationLanguages.map((lang) => lang.abbreviation)
    localStorage.setItem('translationLangs', JSON.stringify(locales))

    const localeOptions = availableTranslationLanguages.map((lang) => ({
        value: lang.abbreviation,
        label: lang.abbreviation.toUpperCase(),
    }))

    return localeOptions
}

export default useLocaleOptions
